export default __webpack_public_path__ + "static/media/goods17.4cd812b5.gif";